import { combineReducers } from 'redux'
import api from './api'
import app from './app'
import apps from './apps'
import entities from './entities'
import entity from './entity'
import isReady from './isReady'
import profile from './profile'
import stats from './stats'
import subscription from './subscription'
import subscriptions from './subscriptions'
import transaction from './transaction'
import transactions from './transactions'
import user from './user'
import users from './users'
import { routerReducer as routing } from 'react-router-redux'

export default combineReducers({
    api,
    app,
    apps,
    entities,
    entity,
    isReady,
    profile,
    routing,
    stats,
    subscription,
    subscriptions,
    transaction,
    transactions,
    user,
    users
})



// WEBPACK FOOTER //
// ./state/reducers/index.js